import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import { useSettings } from '../context/SettingsContext'
import Social from './Social';

const Footer = () => {
    const [pageContent, setPageContent] = useState(null);
    const { renderHTML, services, settings } = useSettings();
    const getPageContent = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/FooterContent`);
            setPageContent(res.data.data)
        } catch (err) {
            console.error('Error fetching Page Content:', err);
        }
    }
    useEffect(() => {
            getPageContent();
            
        }, [])
    return (
        <>
            <footer>
                <div className="container-fluid web-padding">
                    <div className="row footer-top-row">
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>{pageContent?.[0]?.title ?? ''}</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    {renderHTML(pageContent?.[0]?.short_details ?? '')}
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>{pageContent?.[1]?.title ?? ''}</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    {renderHTML(pageContent?.[1]?.short_details ?? '')}
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>{pageContent?.[2]?.title ?? ''}</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    {renderHTML(pageContent?.[2]?.short_details ?? '')}
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>{pageContent?.[3]?.title ?? ''}</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    <p>{renderHTML(pageContent?.[3]?.short_details ?? '')}</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="row footer-lins-row">
                        <div className="col-md-4">
                            <div className="footer-logo">
                                <Link to="/">
                                    {
                                        settings?.logo === null ? <img src="images/footer-logo.png" alt="img" /> : <img src={`${settings?.logo}`} alt="img" />
                                    }

                                </Link>
                                {renderHTML(pageContent?.[4]?.details ?? '')}
                                <h5>Follow Us</h5>
                                <Social />
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="footer-links-wrapper">
                                        <h5>Useful links</h5>
                                        <ul className="footer-links">
                                            <li><Link to="/">Home</Link> </li>
                                            <li><Link to="/about">About us</Link> </li>
                                            <li><Link to="/services">services</Link> </li>
                                            <li><Link to="/product">products</Link> </li>
                                            <li><Link to="/contact">Contact Us</Link> </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <div className="col-md-3">
                                    <div className="footer-links-wrapper">
                                        <h5>Recent jobs</h5>
                                        <ul className="footer-links">
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                            <li><Link to="">About Lorem, ipsum.</Link> </li>
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                        </ul>
                                    </div>
                                </div> */}
                                <div className="col-md-3">
                                    <div className="footer-links-wrapper">
                                        <h5>Quick Links</h5>
                                        <ul className="footer-links">
                                            <li><Link to="/policies">Policies</Link></li>
                                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                            <li><Link to="/terms-and-condition">Terms &amp; Condition</Link></li>
                                            {/* <li><Link to="">Help</Link></li> */}
                                            {/* <li><Link to="">Delivery &amp; Return</Link></li> */}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="footer-links-wrapper">
                                        <h5>Contact Us</h5>
                                        <ul className="footer-links">
                                            <li><p><a href="javascript:void(0);">{settings?.address}</a></p></li>
                                            <li><p><a href={`tel:${settings?.phone}`}>{settings?.phone}</a><br/>
                                            <a href={`tel:${settings?.sec_phone}`}>{settings?.sec_phone}</a></p></li>
                                            <li><p><a href={`mailto:${settings?.email}`} className="email-text">{settings?.email}</a></p></li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="copy-righjt-para">
                            <p>MV tyres ltd © 2026. All Rights Reserved</p>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer